import * as React from "react";
import { FunctionComponent } from "react";
import { describeMove, PlayedMove } from "@mancala/core";
import { useTranslation } from "react-i18next";

// What happened in a move, as tags: extra turn, capture, stones added to the store, game over.
const MoveTags: FunctionComponent<{ moves: PlayedMove[], moveNumber: number }> = ({ moves, moveNumber }) => {
    const { t } = useTranslation();
    const move = describeMove(moves, moveNumber);
    return (
        <span className="tags">
            {move.extraTurn && <span className="tag x">{t("ExtraTurn")}</span>}
            {move.capture && <span className="tag c">{t("Capture")}</span>}
            {move.storeGain > 0 && <span className="tag">{t("StoreGain", { count: move.storeGain })}</span>}
            {move.gameOver && <span className="tag">{t("GameOver")}</span>}
        </span>
    );
};

export default MoveTags;
